import { Button, Notification, Select, SelectOption } from "@rio-cloud/rio-uikit";
import { useNavigateToBoard } from "./useNavigateToBoard";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUserProfile } from "../../../../configuration/login/loginSlice";
import SubNavigation from '@rio-cloud/rio-uikit/SubNavigation';
import { useEffect, useState } from "react";
import CardInfo from "./components/CardInfo";
import CardStatus, { UserTas } from "./components/CardStatus";
import Occurrence from "./components/Occurrence";
import AdditionalData from "./components/AdditionalData";
import { edithOccurrencesDetail, exportOccurrencePdf, fetchOccurrencesDetail, fetchSupportLogs, fetchSupportRegionals, fetchSupportVehicle, fetchUsers } from "../../../../api/tas";
import { IOccurrence, LogOccurence, OccurrenceStatus, VehicleSupport } from "../../types";
import moment from 'moment';
import { optionsAdministrative, optionsFinancial, optionsTechnical, optionsVolksTotalPortal, SupportType, typeStatusOccurence, typesOcorrenceStatus } from "../../constants";
import { ChatOccurrenceTas } from "../chat";
import { useTasOccurrenceChat } from "../../../../hooks/useTasOccurrenceChat";
import { useTasOccurrenceChatVWCO } from "../../../../hooks/useTasOccurrenceChatVWCO";
import { useIntl } from "react-intl";
import { fetchUserRole } from "../../../../api/fetchUser";
import SupportAttachmentsPage from "../Attachments";
import VehicleData from "./components/VehiclesData";
import AdditionalDataTas from "./components/AditionalDataTas";
import SupportHistoryPage from "../supportHistory";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { fetchOccurrence, fetchOccurrenceSummary } from "../../../../api/fetchOccurence";
import { BudgetRecipientEnum } from "../../../../components/budgetsV1/budgetsForm/createAndEdit/types";
import { fetchBudgetUserProfile } from "../../../../api/fetchBudget";
import SelectCustom from "../../../../components/selectCustom";
import { BudgetRecipient } from "../../../../components/budgetsV2/enums/budgetRecipient";
import { MoveStepDialog } from "./dialogs/MoveStepDialog";
import ChangeGroupDialog from "./dialogs/ChangeGroupDialog";
import { fetchSupportGroupUsers } from "../../../../api/supportGroups";
import { useSupportGroupOptions } from "../../../../hooks/useSupportGroups";
import ErrorDialog from "../../../../components/dialogs/ErrorDialog";
import HistoryOcurrence from "../../components/HistoryOccurence";
import UnsavedChangesLeaveDialog from "./components/UnsavedChangesLeaveDialog";
import { buildEditPayload } from "./utils/build-edit-payload";
import { getTasAdditionalFields, isTasAdditionalFieldRequired } from "../../newSupportCall/tasAdditionalRequiredFields";
import { isVolkswagenEmail } from "../../../../utils/emailUtils";
import { entryDatesAreEqual, normalizeEntryDate } from "../../entryDate";
import { Occurrence as MainOccurrence } from "../../../../models/occurrence";
import MainOccurenceCard from "../../components/MainOcurrenceCard";
import { getSupportSubjectOptions, getSupportThemeOptions } from "../../utils";
import VehicleHistoryPage from "../vehicleHistory";

export type ErrorsType = {
    odometer?: boolean;
    hourMeter?: boolean;
    
    chassis?: boolean;
    licensePlate?: boolean;
    entryDate?: boolean;
    partOrComponentName?: boolean;
    partNumber?: boolean;
    customerComment?: boolean;
    problemDescription?: boolean;
    diagnosticAndResults?: boolean;
    problemSteps?: boolean;
}

const SupportDetailsPage = () => {
    const navigate = useNavigate();
    const intl = useIntl();
    const location = useLocation();
    const [selected, setSelected] = useState<undefined | string[]>(undefined);
    const [data, setData] = useState<IOccurrence | undefined>(undefined);
    const [responsible, setResponsible] = useState('');
    const [dn, setDn] = useState('');
    const [chassis, setChassis] = useState('');
    const [licensePlate, setLicensePlate] = useState('');
    const [customer, setCustomer] = useState('');
    const [dnResponsible, setDnResponsible] = useState('');
    const [hourMeter, setHourMeter] = useState(0);
    const [odometer, setOdometer] = useState(0);
    const [entryDate, setEntryDate] = useState('');
    const [isLoadingSaveForm, setIsLoadingSaveForm] = useState(false);
    const [isLoadingEdit, setIsLoadingEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState<UserTas[]>([]);
    const [selectedUser, setSelectedUser] = useState<undefined | string[]>(undefined);
    const [selectedUserName, setSelectedUserName] = useState<string>('')
    const [selectedGroup, setSelectedGroup] = useState<undefined | string[]>(undefined);
    const [pendingGroup, setPendingGroup] = useState<UserTas | undefined>(undefined);
    const groupOptions = useSupportGroupOptions();
    const [isControlTower, setIsControlTower] = useState(false);
    const [isConsultant, setIsConsultant] = useState(false);
    const [roleLoaded, setRoleLoaded] = useState(false);
    const [optionsRegionals, setOptionsRegionals] = useState<SelectOption[]>([]);
    const [selectedRegional, setSelectedRegional] = useState<undefined | string[]>(undefined);
    const [customerComment, setCustomerComment] = useState('');
    const [diagnose, setDiagnose] = useState('');
    const [repair, setRepair] = useState('');
    const [analysisReason, setAnalysisReason] = useState('');
    const [partName, setPartName] = useState('');
    const [aeg, setAeg] = useState('');
    const [phone, setPhone] = useState('');
    const [vehicleQtd, setVehicleQtd] = useState('');
    const [cancelComment, setCancelComment] = useState('');
    const [partOrComponentName, setPartOrComponentName] = useState('');
    const [partNumber, setPartNumber] = useState('');
    const [problemDescription, setProblemDescription] = useState('');
    const [diagnosticAndResults, setDiagnosticAndResults] = useState('');
    const [problemSteps, setProblemSteps] = useState('');
    const [failureFrequency, setFailureFrequency] = useState('');
    const [failCodes, setFailCodes] = useState('');
    const [observations, setObservations] = useState('');
    const [vehicle, setVehicle] = useState<VehicleSupport | null>(null);
    const [isLoadingChassis, setIsLoadingChassis] = useState(false);
    const [cancelReason, setCancelReason] = useState('');
    const [occurrenceId, setOccurrenceId] = useState<string | undefined | null>(undefined);
    const [occurrenceData, setOccurrenceData] = useState<MainOccurrence | undefined>(undefined);
    const [profile, setProfile] = useState<BudgetRecipientEnum | undefined>(undefined);
    const showVinculateOccurrence = useFeatureFlag('tas-occurrence.vinculated-occurrence');
    const showLogsTab = useFeatureFlag('tas-occurrence.logs-tab');
    const showVehicleContainer = useFeatureFlag('tas-occurrence.vehicle-container');
    const [showAdvanceStepDialog, setShowAdvanceStepDialog] = useState(false);
    const [closePage, setClosePage] = useState(false);
    const [advanceStatus, setAdvanceStatus] = useState<undefined | string[]>(undefined);
    const [subject, setSubject] = useState('');
    const [subtopic, setSubtopic] = useState('');
    const [showNonVolksMoveErrorDialog, setShowNonVolksMoveErrorDialog] = useState(false);
    const [showLeaveConfirmDialog, setShowLeaveConfirmDialog] = useState(false);
    const [stepPromptPending, setStepPromptPending] = useState(false);
    const userProfile = useSelector(getUserProfile);
    const isVwEmail = isVolkswagenEmail(userProfile?.email);

    //LOGS
    const [logOccurence, setLogOccurence] = useState<LogOccurence[]>([]);
    const [startDate, setStartDate] = useState(moment().subtract(30, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const [status, setStatus] = useState<undefined | string[]>(undefined);
    const [userSearch, setUserSearch] = useState('');
    const [isLoadingLogs, setIsLoadingLogs] = useState(false);
    const [isDuplicated, setIsDuplicated] = useState(false);
    
    const initialErrors: ErrorsType = {
        chassis: false,
        odometer: false,
        hourMeter: false,
        entryDate: false,
    };

    const [errors, setErrors] = useState<ErrorsType>(initialErrors);

    const [isExportingPdf, setIsExportingPdf] = useState(false);

    const normalizeValue = (value: unknown) => {
        if (
            value === null ||
            value === undefined ||
            (typeof value === "string" && value.trim() === "")
        ) {
            return null;
        }

        return value;
    };

    const navigateToBoard = useNavigateToBoard();

    const [searchParams] = useSearchParams();

    const id = searchParams.get("id");

    // CHAT
    const tasOccurrenceChat = useTasOccurrenceChat(id ?? "");
    const showVwcoChat = roleLoaded && !isConsultant;
    const vwcoChat = useTasOccurrenceChatVWCO(id ?? "", showVwcoChat);

    const handleExportPdf = async () => {
        if (!id) return;

        setIsExportingPdf(true);
        try {
            const response = await exportOccurrencePdf(id);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `chamado-${id}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('[SupportDetailsPage] Erro ao exportar PDF do chamado:', error);
            Notification.error(intl.formatMessage({ id: "intl-msg:support.details.exportPdfError" }));
        } finally {
            setIsExportingPdf(false);
        }
    };

    const tab = searchParams.get("tab");

    const activeTab = (() => {
        if (tab === "chat") {
            return "chat";
        }

        if (tab === "chatVwco" && showVwcoChat) {
            return "chatVwco";
        }

        if (tab === 'attachments') {
            return "attachments";
        }

        if (tab === 'supportHistory') {
            return "supportHistory";
        }

        if (tab === 'VehicleHistory') {
            return "VehicleHistory";
        }

        return "summary";
    })();

    const tabPath = (tab: "summary" | "chat" | "chatVwco" | 'attachments' | 'supportHistory' | 'VehicleHistory') => {
        const params = new URLSearchParams(searchParams);
        if (tab === "chat") {
            params.set("tab", "chat");
        } else if (tab === "chatVwco") {
            params.set("tab", "chatVwco");
        } else if (tab === "attachments") {
            params.set('tab', "attachments")
        } else if (tab === "supportHistory") {
            params.set('tab', "supportHistory")
        } else if (tab === "VehicleHistory") {
            params.set('tab', "VehicleHistory")
        } else {
            params.delete("tab");
        }
        const query = params.toString();
        return `${location.pathname}${query ? `?${query}` : ""}`;
    };

    const handleCheckInput = () => {
        const isTechnicalSubject = subject === 'TECHNICAL';
        const isTechnicalSupport = data?.supportType === 'TECHNICAL_SUPPORT';
        const hasChassisValue = Boolean(chassis);

        const tasAdditionalValues: Record<string, unknown> = {
            partOrComponentName, partNumber, customerComment, diagnosticAndResults, problemSteps
        };

        const tasAdditionalErrors: ErrorsType = isTechnicalSupport
            ? Object.fromEntries(
                getTasAdditionalFields(subject)
                    .filter(isTasAdditionalFieldRequired)
                    .filter(field => field.field in tasAdditionalValues)
                    .map(field => [field.field, normalizeValue(tasAdditionalValues[field.field]) === null]),
            )
            : {};
        

        const fields: ErrorsType = {
            chassis: isTechnicalSubject || isTechnicalSupport ? chassis?.length !== 17
                : hasChassisValue && chassis.length !== 17,
            odometer: isTechnicalSubject || isTechnicalSupport ? !odometer : false,
            hourMeter: isTechnicalSubject ? !hourMeter : false,
            entryDate: isTechnicalSubject || isTechnicalSupport ? !moment(entryDate).isValid() : false,
            licensePlate: isTechnicalSubject || isTechnicalSupport ? !licensePlate : false,
            ...tasAdditionalErrors,
        };

        setErrors(fields);

        return !Object.values(fields).some(Boolean);
    };

    const fetchRegionals = async () => {
        const res = await fetchSupportRegionals();
        if (res?.content) {
            setOptionsRegionals(res?.content?.map((res: { id: number, name: string }) => {
                return {
                    id: res.id.toString(),
                    label: res.name,
                }
            }))
        }
    };

    const fetchOccurrencesDetails = async (silent = false) => {
        if (!silent) {
            setIsLoading(true);
        }

        try {
            if (!id) {
                throw new Error('NO_DATA');
            };

            const res = await fetchOccurrencesDetail(id);
            setSelected([res.status]);
            setData(res);
            setResponsible(res.responsible);
            setDn(res.dn);
            setChassis(res.chassis);
            setLicensePlate(res.licensePlate);
            setCustomer(res.customer);
            setDnResponsible(res.dnResponsible);
            setHourMeter(res.hourMeter);
            setOdometer(res.odometer);
            setEntryDate(normalizeEntryDate(res.entryDate));
            setSelectedUser([res.assignedToId]);
            setSelectedUserName(res.assignedTo);
            setSelectedGroup(res.assignedGroupId ? [String(res.assignedGroupId)] : undefined);
            setSelectedRegional(res.regionalId ? [res.regionalId?.toString()] : undefined);
            setCustomerComment(res.customerComment);
            setDiagnose(res.diagnose);
            setRepair(res.repair);
            setAnalysisReason(res.analysisReason);
            setPartName(res.partName);
            setAeg(res.aeg);
            setPhone(res.phone)
            setCancelComment(res.cancelComment);
            setVehicleQtd(res.vehicleQtd?.toString())
            setPartOrComponentName(res.partOrComponentName);
            setPartNumber(res.partNumber)
            setProblemDescription(res.problemDescription);
            setDiagnosticAndResults(res.diagnosticAndResults);
            setProblemSteps(res.problemSteps);
            setFailureFrequency(res.failureFrequency);
            setFailCodes(res.failCodes ?? '');
            setObservations(res.observations ?? '');
            setCancelReason(res.cancelReason);
            setOccurrenceId(res.mainOccurrenceId)
            setSubject(res.subject);
            setSubtopic(res.subtopic)
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }
    }

    const fetchUsersList = async (groupId?: string) => {
        const res = groupId ? await fetchSupportGroupUsers(Number(groupId)) : await fetchUsers();
        const transformed = res.map((user: { id: string, firstName: string, lastName: string }) => {
            return {
                id: user.id,
                label: `${user.firstName} ${user.lastName}`
            }
        })
        return transformed;
    }

    const fetchRole = async () => {
        try {
            const role = await fetchUserRole();
            setIsControlTower(role === 'TOWER');
            setIsConsultant(role === 'CONSULTANT' || role === 'GROUP_CONSULTANT');
        } finally {
            setRoleLoaded(true);
        }
    };

    const fetchVehicle = async () => {
        setIsLoadingChassis(true);

        try {
            const res = await fetchSupportVehicle(chassis);
            setVehicle(res);
            if (res?.licensePlate) {
                setLicensePlate(res.licensePlate);
            };

        } catch (error) {
            setVehicle(null);
        } finally {
            setIsLoadingChassis(false);
        }
    }

    const fetchLogs = async () => {
        setIsLoadingLogs(true);

        if (!id) {
            return;
        }

        try {
            const isEmptyValue = (value: unknown) => {
                return (
                    value === null ||
                    value === undefined ||
                    value === "" ||
                    value === 0 ||
                    value === "0"
                );
            };

            const ignoredFields = [
                "id",
                "createdBy",
                "createdById",
                "updatedById",
                "statusUpdatedAt",
                "createdAt",
                "updatedAt",
                "tasOccurrenceNumber",
                "assignedToId",
            ];


            const res = await fetchSupportLogs({
                id,
                searchTerm: status?.[0] || undefined,
                userName: userSearch,
                endDate: `${endDate}T23:59:00Z`,
                startDate: `${startDate}T00:00:00Z`,
            });

            // Apenas criação da ocorrência principal
            const occurrenceCreate = res?.content?.find(
                (item: { action: string; entity: string }) =>
                    item.action === "CREATE" &&
                    item.entity === "TAS_OCCURRENCE"
            );

            const statusCreate = occurrenceCreate?.data?.find(
                (item: {
                    input: string;
                    newData?: string | number;
                    oldData?: string | number | null;
                }) => item.input === "status"
            );

            const start: LogOccurence[] = occurrenceCreate
                ? [
                    {
                        action: "CREATE",
                        createdAt: occurrenceCreate.createdAt,
                        fieldChanged: "intl-msg:support.details.logOccurrenceCreated",
                        id: occurrenceCreate.id,
                        old: "",
                        new: "",
                        status: statusCreate?.newData ?? "",
                        user: occurrenceCreate.userName,
                    },
                ]
                : [];

            const changes: LogOccurence[] = res?.content?.flatMap(
                (log: {
                    id: number;
                    action: string;
                    entity: string;
                    createdAt: string;
                    userName: string;
                    description: string;
                    oldData?: any;
                    newData?: any;
                    data: {
                        input: string;
                        oldData?: string | number | null;
                        newData?: string | number | null;
                    }[];
                }) => {
                    // CREATE da ocorrência principal já foi tratado em start
                    if (
                        log.action === "CREATE" &&
                        log.entity === "TAS_OCCURRENCE"
                    ) {
                        return [];
                    }

                    // CREATE COMMENT
                    if (
                        log.action === "CREATE" &&
                        log.entity === "TAS_OCCURRENCE_COMMENT"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "intl-msg:support.details.logCommentCreated",
                                id: log.id,
                                old: "",
                                new: log.newData?.comment ?? "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // CREATE FILE
                    if (
                        log.action === "CREATE" &&
                        log.entity === "TAS_OCCURRENCE_FILE"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "intl-msg:support.details.logFileAttached",
                                id: log.id,
                                old: "",
                                new: log.newData?.name ?? "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // UPDATE COMMENT
                    if (
                        log.action === "UPDATE" &&
                        log.entity === "TAS_OCCURRENCE_COMMENT"
                    ) {
                        const commentChange = log.data.find(
                            item => item.input === "comment"
                        );

                        if (!commentChange) {
                            return [];
                        }

                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "intl-msg:support.details.logCommentEdited",
                                id: log.id,
                                old: commentChange.oldData ?? "",
                                new: commentChange.newData ?? "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // UPDATE FILE
                    if (
                        log.action === "UPDATE" &&
                        log.entity === "TAS_OCCURRENCE_FILE"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "intl-msg:support.details.logFileUpdated",
                                id: log.id,
                                old: log.oldData?.name ?? "",
                                new: log.newData?.name ?? "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // UPDATE OCCURRENCE
                    if (
                        log.action === "UPDATE" &&
                        log.entity === "TAS_OCCURRENCE"
                    ) {
                        return log.data
                            .filter(item => {
                                if (ignoredFields.includes(item.input)) {
                                    return false;
                                }

                                if (
                                    isEmptyValue(item.oldData) &&
                                    isEmptyValue(item.newData)
                                ) {
                                    return false;
                                }

                                return item.oldData !== item.newData;
                            })
                            .map(item => ({
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: item.input,
                                id: log.id,
                                old: item.oldData ?? "",
                                new: item.newData ?? "",
                                status: log.description,
                                user: log.userName,
                            }));
                    }

                    // DELETE COMMENT
                    if (
                        log.action === "DELETE" &&
                        log.entity === "TAS_OCCURRENCE_COMMENT"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "intl-msg:support.details.logCommentRemoved",
                                id: log.id,
                                old: "",
                                new: "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // DELETE FILE
                    if (
                        log.action === "DELETE" &&
                        log.entity === "TAS_OCCURRENCE_FILE"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "intl-msg:support.details.logFileRemoved",
                                id: log.id,
                                old: "",
                                new: log.oldData?.name ?? "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    // DELETE OCCURRENCE
                    if (
                        log.action === "DELETE" &&
                        log.entity === "TAS_OCCURRENCE"
                    ) {
                        return [
                            {
                                action: log.action,
                                createdAt: log.createdAt,
                                fieldChanged: "intl-msg:support.details.logOccurrenceRemoved",
                                id: log.id,
                                old: "",
                                new: "",
                                status: log.description,
                                user: log.userName,
                            },
                        ];
                    }

                    return [];
                }
            );

            const logs = [...start, ...changes];

            logs.sort(
                (a, b) =>
                    new Date(b.createdAt).getTime() -
                    new Date(a.createdAt).getTime()
            );

            setLogOccurence(logs);
        } catch (error) {
            setLogOccurence([]);
        } finally {
            setIsLoadingLogs(false);
        }
    };

    useEffect(() => {
        fetchRole();
        fetchRegionals();
        fetchOccurrencesDetails();
        fetchLogs();
    }, [id])

    useEffect(() => {
        let cancelled = false;
        fetchUsersList(selectedGroup?.[0])
            .then(list => { if (!cancelled) setUsers(list); })
            .catch(error => console.log(error));
        return () => { cancelled = true; };
    }, [selectedGroup?.[0]]);

    useEffect(() => {
        if (chassis?.length === 17) {
            fetchVehicle();
        }
    }, [chassis]);

    useEffect(() => {
        const loadProfile = async () => {
            const profileFetched = await fetchBudgetUserProfile();
            if (profileFetched) {
                setProfile(profileFetched);
            }
        };
        loadProfile();
    }, []);

    useEffect(() => {
        const loadOccurrenceData = async () => {
            if (!occurrenceId) {
                return;
            }

            try {
                const occurrenceResponse = await fetchOccurrence(occurrenceId || '', "TOWER");

                setOccurrenceData(occurrenceResponse);
                
                if (!chassis) setChassis(occurrenceResponse?.vehicleChassis || '');
                if (!licensePlate) setLicensePlate(occurrenceResponse?.vehicleLicensePlate || '');
                if (!customer) setCustomer(occurrenceResponse?.customer || '');
                if (!odometer) setOdometer(occurrenceResponse?.vehicleOdometer ? Number(occurrenceResponse?.vehicleOdometer) : 0);
                if (!hourMeter) setHourMeter(occurrenceResponse?.vehicleHourmeter ? Number(occurrenceResponse?.vehicleHourmeter) : 0);
                if (!phone) setPhone(occurrenceResponse?.dealershipPhone || '');

            } catch (error) {
                
            }
        };

        loadOccurrenceData();
    }, [occurrenceId]);

    const getEditPayloadFields = () => ({
        responsible,
        dn,
        chassis,
        licensePlate,
        customer,
        dnResponsible,
        hourMeter,
        odometer,
        entryDate,
        selectedUserName,
        selectedGroup,
        customerComment,
        diagnose,
        repair,
        analysisReason,
        partName,
        aeg,
        cancelComment,
        partOrComponentName,
        problemDescription,
        diagnosticAndResults,
        problemSteps,
        failureFrequency,
        failCodes,
        observations,
        phone,
        cancelReason,
        subject,
        subtopic,
        selectedUser: selectedUser || [],
        selectedRegional: selectedRegional || [],
        vehicleQtd: Number(vehicleQtd) || 0,
        partNumber: Number(partNumber) || 0,
        occurrenceId,
    });

    const valuesAreEqual = (current: unknown, original: unknown) => {
        return normalizeValue(current) === normalizeValue(original);
    };

    const numbersAreEqual = (current: unknown, original: unknown) => {
        return (Number(current) || 0) === (Number(original) || 0);
    };

    const hasUnsavedChanges = (): boolean => {
        if (!data || isLoading) {
            return false;
        }

        const status = (selected?.[0] as OccurrenceStatus) ?? data.status;
        const payload = buildEditPayload(data, status, getEditPayloadFields());

        return (
            tasOccurrenceChat.isNewComment ||
            vwcoChat.isNewComment ||
            !valuesAreEqual(payload.responsible, data.responsible) ||
            !valuesAreEqual(payload.dn, data.dn) ||
            !valuesAreEqual(payload.chassis, data.chassis) ||
            !valuesAreEqual(payload.licensePlate, data.licensePlate) ||
            !valuesAreEqual(payload.customer, data.customer) ||
            !valuesAreEqual(payload.dnResponsible, data.dnResponsible) ||
            !numbersAreEqual(payload.hourMeter, data.hourMeter) ||
            !numbersAreEqual(payload.odometer, data.odometer) ||
            !entryDatesAreEqual(entryDate, data.entryDate) ||
            !valuesAreEqual(payload.status, data.status) ||
            !valuesAreEqual(payload.assignedToId, data.assignedToId) ||
            !numbersAreEqual(payload.assignedGroupId, data.assignedGroupId) ||
            !numbersAreEqual(payload.regionalId, data.regionalId) ||
            !valuesAreEqual(payload.customerComment, data.customerComment) ||
            !valuesAreEqual(payload.diagnose, data.diagnose) ||
            !valuesAreEqual(payload.repair, data.repair) ||
            !valuesAreEqual(payload.analysisReason, data.analysisReason) ||
            !valuesAreEqual(payload.partName, data.partName) ||
            !valuesAreEqual(payload.aeg, data.aeg) ||
            !valuesAreEqual(payload.phone, data.phone) ||
            !numbersAreEqual(payload.vehicleQtd, data.vehicleQtd) ||
            !valuesAreEqual(payload.cancelComment, data.cancelComment) ||
            !valuesAreEqual(payload.partOrComponentName, data.partOrComponentName) ||
            !numbersAreEqual(payload.partNumber, data.partNumber) ||
            !valuesAreEqual(payload.problemDescription, data.problemDescription) ||
            !valuesAreEqual(payload.diagnosticAndResults, data.diagnosticAndResults) ||
            !valuesAreEqual(payload.problemSteps, data.problemSteps) ||
            !valuesAreEqual(payload.failureFrequency, data.failureFrequency) ||
            !valuesAreEqual(payload.failCodes, data.failCodes) ||
            !valuesAreEqual(payload.observations, data.observations) ||
            !valuesAreEqual(payload.cancelReason, data.cancelReason) ||
            !valuesAreEqual(payload.mainOccurrenceId ?? null, data.mainOccurrenceId ?? null) ||
            !valuesAreEqual(payload.subject, data.subject) ||
            !valuesAreEqual(payload.subtopic, data.subtopic)
        );
    };

    useEffect(() => {
        if (showAdvanceStepDialog) {
            setStepPromptPending(false);
        }
    }, [showAdvanceStepDialog]);

    const handleGoBack = () => {
        if (hasUnsavedChanges()) {
            setShowLeaveConfirmDialog(true);
            return;
        }

        if (stepPromptPending) {
            setAdvanceStatus(undefined);
            setClosePage(true);
            setShowAdvanceStepDialog(true);
            return;
        }

        navigate("/control-tower/support");
    };

    const markAsSaved = async (stepChanged: boolean) => {
        await fetchOccurrencesDetails(true);
        tasOccurrenceChat.resetIsNewComment();
        vwcoChat.resetIsNewComment();
        setStepPromptPending(!stepChanged);
    };

    const handleLeaveWithoutSaving = () => {
        setShowLeaveConfirmDialog(false);
        navigate("/control-tower/support");
    };

    const handleNavigateCreate = () => {
        const params = new URLSearchParams(location.search)
        const basePath = location.pathname.substring(
            0,
            location.pathname.lastIndexOf('/')
        );

        navigate(`${basePath}/new-support-call?${params.toString()}`);
    }

    const updateOccurrence = async (id: string, status: OccurrenceStatus, data: IOccurrence) => {
        await edithOccurrencesDetail(id, buildEditPayload(data, status, getEditPayloadFields()));
    }

    const editOccurrence = async () => {
        const isError = handleCheckInput();

        if (!isError) {
            return false;
        }

        if (!id || !data) {
            throw new Error('NO DATA');
        }

        const status = selected?.[0] as OccurrenceStatus;

        if (
            data.status === 'OPEN' &&
            status === 'IN_ANALYSIS' &&
            !isVwEmail
        ) {
            setShowNonVolksMoveErrorDialog(true);
            return false;
        }

        await updateOccurrence(id, status, data);

        Notification.success(intl.formatMessage({ id: "intl-msg:tas.occurrence.successAdvanceStepTitle" }));
        await markAsSaved(data.status !== status);

        return true;
    };

    const saveForm = async () => {
        setIsLoadingSaveForm(true);

        try {
            await editOccurrence();

        } catch (error) {
            Notification.error(intl.formatMessage({ id: "intl-msg:support.details.editError" }))
        } finally {
            setIsLoadingSaveForm(false);
        }
    };

    const handleEdit = async (isDuplicate?: boolean, closePage?: boolean) => {
        setIsLoadingEdit(true);
        setIsDuplicated(isDuplicate || false);

        try {
            if (!data) {
                throw new Error('NO DATA');
            }

            const status = selected?.[0] as OccurrenceStatus;
            const wasMovedManually = data.status !== status;

            const success = await editOccurrence();

            if (!success) {
                return;
            }

            if (isDuplicate) {
                handleNavigateCreate();
                return;
            }

            if (!wasMovedManually) {
                setAdvanceStatus(undefined);
                setClosePage(Boolean(closePage));
                setShowAdvanceStepDialog(true);
                return;
            }

            if (closePage) {
                navigateToBoard();
            }
        } catch (error) {
            Notification.error(intl.formatMessage({ id: "intl-msg:support.details.editError" }));
        } finally {
            setIsLoadingEdit(false);
        }
    };

    const handleLeaveWithSave = () => {
        setShowLeaveConfirmDialog(false);
        handleEdit(false, true);
    };

    const handleDuplicateOcurrence = () => {
        handleEdit(true, true)
    };

    const applyGroup = (group: UserTas) => {
        setSelectedGroup([group.id]);
        setSelectedUser(['']);
        setSelectedUserName('');
        setPendingGroup(undefined);
    };

    const handleSelectedGroup = (group?: UserTas) => {
        if (!group) {
            setSelectedGroup(undefined);
            return;
        }
        if (group.id === selectedGroup?.[0]) {
            return;
        }
        if (selectedUser?.[0]) {
            setPendingGroup(group);
            return;
        }
        applyGroup(group);
    };

    const handleSelectedUser = (u?: UserTas) => {
        setSelectedUser([u?.id || '']);
        setSelectedUserName(u?.label || '');
    };

    const handleApplyFilterLog = () => {
        fetchLogs();
    }

    const disabledMove = isConsultant ? data?.status === 'ANSWERED' ? false : true : !isControlTower;

    const handleLoadMore = async (searchTerm?: string, pageSize?: number, page?: number): Promise<{ id: string, label: string | string }[]> => {
        const res = await fetchOccurrenceSummary(
            profile as unknown as BudgetRecipient,
            searchTerm,
            undefined,
            chassis,
        )

        if (!res.length) {
            return []
        };


        return res?.filter(e => e.protocolNumber !== '')?.map((o) => {
            return {
                id: o.uuid,
                label: <div className="display-flex flex-column gap-2">
                    <div><span>{o.protocolNumber}</span></div>
                    <div><span className="text-size-12 text-color-gray">{o.vehicleChassis}</span></div>
                </div> as any,
            }
        })
    }

    const handleSubject = (sub: string) => {
        setSubject(sub);

        if (sub === SupportType.ADMINISTRATIVE) {
            setSubtopic(optionsAdministrative[0].id)
            return;
        }

        if (sub === SupportType.FINANCIAL) {
            setSubtopic(optionsFinancial[0].id)
            return;
        }

        if (sub === SupportType.PORTAL) {
            setSubtopic(optionsVolksTotalPortal[0].id)
            return;
        }

        if (sub === SupportType.TECHNICAL) {
            setSubtopic(optionsTechnical[0].id)
        }
    }

    const handleCloseDetails = () => {
        handleGoBack();
    }
    useEffect(() => {
        if (showAdvanceStepDialog) {
            setStepPromptPending(false);
        }
    }, [showAdvanceStepDialog]);

    useEffect(() => {
        handleLoadMore();
    }, [])

    return (
        <div className="width-100pct height-100pct display-flex justify-content-center align-items-center">
            <div className="panel panel-default panel-body height-100pct shadow-default margin-top-20" style={{ width: 1400 }}>
                <div className="border border-bottom-only padding-y-10" style={{ display: 'flex', alignItems: 'center !important', justifyContent: 'space-between' }}>
                    <div className="display-flex align-items-center gap-10">
                        <span className="text-size-h4 align-self-center">{intl.formatMessage({ id: "intl-msg:support.details.title" })}</span>
                        <span className="text-size-h4 align-self-center">{data?.tasOccurrenceNumber ? `${data.tasOccurrenceNumber}` : ''}</span>
                    </div>
                    <Button bsStyle={Button.MUTED} iconOnly iconName='rioglyph-remove' className="text-color-black" onClick={handleCloseDetails} />
                </div>

                <div className="width-100pct margin-top-20">
                    <label htmlFor="type">{intl.formatMessage({ id: "intl-msg:tas.occurrence.moveTo" })}</label>
                    <Select
                        id="type"
                        bsSize='lg'
                        value={selected}
                        onChange={(item) => setSelected([item?.id as string])}
                        options={typeStatusOccurence.map((type) => {
                            return {
                                id: type.id,
                                label: intl.formatMessage({ id: type.labelId }),
                                disabled: isConsultant && type.id === 'OPEN',
                            }
                        })}
                        disabled={disabledMove}
                        placeholder={intl.formatMessage({ id: "intl-msg:support.details.searchTypePlaceholder" })}
                    />
                </div>

                <div className="width-100pct margin-top-20">
                    <div className="border border-bottom-only margin-top-20" style={{display: 'flex', alignItems: 'center'}}>
                        <SubNavigation
                            navItems={[
                                {
                                    key: '1',
                                    route: (
                                        <Link
                                            to={tabPath("summary")}
                                            replace
                                            preventScrollReset
                                            className={`${activeTab === "summary" ? "active" : ""} padding-x-10`}
                                            aria-current={activeTab === "summary" ? "page" : undefined}
                                        >
                                            {intl.formatMessage({ id: "intl-msg:tas.support.details.summary" })}
                                        </Link>
                                    ),
                                },
                                {
                                    key: '2',
                                    route: (
                                        <Link
                                            to={tabPath("chat")}
                                            replace
                                            preventScrollReset
                                            className={`${activeTab === "chat" ? "active" : ""} padding-x-10`}
                                            aria-current={activeTab === "chat" ? "page" : undefined}
                                        >
                                            {intl.formatMessage({ id: "intl-msg:tas.support.details.chat" })}
                                        </Link>
                                    ),
                                },
                                {
                                    key: '5',
                                    route: showVwcoChat ? (
                                        <Link
                                            to={tabPath("chatVwco")}
                                            replace
                                            preventScrollReset
                                            className={`${activeTab === "chatVwco" ? "active" : ""} padding-x-10`}
                                            aria-current={activeTab === "chatVwco" ? "page" : undefined}
                                        >
                                            {intl.formatMessage({ id: "intl-msg:tas.support.details.chatVwco" })}
                                        </Link>
                                    ) : <></>,
                                },

                                {
                                    key: '3',
                                    route: (
                                        <Link
                                            to={tabPath("attachments")}
                                            replace
                                            preventScrollReset
                                            className={`${activeTab === "attachments" ? "active" : ""} padding-x-10`}
                                            aria-current={activeTab === "attachments" ? "page" : undefined}
                                        >
                                            {intl.formatMessage({ id: "intl-msg:tas.support.details.attachments" })}
                                        </Link>
                                    ),
                                },
                                {
                                    key: '4',
                                    route: showLogsTab ?
                                        <Link
                                            to={tabPath("supportHistory")}
                                            replace
                                            preventScrollReset
                                            className={`${activeTab === "supportHistory" ? "active" : ""} padding-x-10`}
                                            aria-current={activeTab === "supportHistory" ? "page" : undefined}
                                        >
                                            {intl.formatMessage({ id: "intl-msg:tas.support.details.supportHistory" })}
                                        </Link>
                                        : <></>,
                                },
                                {
                                    key: '5',
                                    route: showLogsTab ?
                                        <Link
                                            to={tabPath("VehicleHistory")}
                                            replace
                                            preventScrollReset
                                            className={`${activeTab === "VehicleHistory" ? "active" : ""} padding-x-10`}
                                            aria-current={activeTab === "VehicleHistory" ? "page" : undefined}
                                        >
                                            {intl.formatMessage({ id: "intl-msg:tas.support.details.vehicleHistory" })}
                                        </Link>
                                        : <></>,
                                }
                            ]}
                        />

                        {activeTab === 'summary' && (
                            <div className=" padding-bottom-0">
                                <button
                                    type="button"
                                    className={`btn btn-primary btn-outline ${isExportingPdf ? 'btn-loading disabled' : ''}`}
                                    disabled={isExportingPdf || !id}
                                    onClick={handleExportPdf}
                                >
                                    <span className="rioglyph rioglyph-download margin-right-5"></span>
                                    {intl.formatMessage({ id: "intl-msg:support.details.exportData" })}
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="display-flex width-100pct height-100pct margin-top-20 gap-20">
                        <div className="flex-1-1 display-flex flex-column">
                            {activeTab === 'summary' && (
                                <>
                                    <div className="width-100pct display-flex" style={{ height: data?.supportType !== 'CONTRACT_CANCELLATION' && data?.supportType !== 'COMMERCIAL' ? 380 : 337.91 }}>
                                        <div className="width-100pct height-100pct">
                                            <CardInfo
                                                subject={data?.subject}
                                                supportType={data?.supportType}
                                                subtopic={data?.subtopic}
                                                createdBy={data?.createdBy}
                                                createdAt={data?.createdAt}
                                                updatedAt={data?.updatedAt}
                                                timeInStatus={data?.timeInStatus}
                                                statusUpdatedAt={data?.statusUpdatedAt}
                                                isLoading={isLoading}
                                            />
                                        </div>
                                        <div className="width-100pct height-100pct">
                                            <CardStatus
                                                status={data?.status}
                                                createdAt={data?.createdAt}
                                                isLoading={isLoading}
                                                users={users}
                                                groups={groupOptions}
                                                selectedGroup={selectedGroup}
                                                assignedGroupName={data?.assignedGroupName}
                                                handleSelectedGroup={handleSelectedGroup}
                                                selectedUser={selectedUser}
                                                handleSelectedUser={handleSelectedUser}
                                                isControlTower={isControlTower}
                                                isVwEmail={isVwEmail}
                                            />
                                        </div>
                                    </div>

                                    <div className='padding-top-20'>
                                        <span className='text-size-14 text-color-darker'>{intl.formatMessage({ id: "intl-msg:support.subject" })}</span>
                                        <div className='form-group form-group-lg padding-top-10'>
                                            <Select
                                                bsSize='lg'
                                                value={subject ? [subject] : []}
                                                onChange={option => handleSubject(option?.id || '')}
                                                options={getSupportSubjectOptions(intl, data?.supportType)}
                                                placeholder={intl.formatMessage({ id: "intl-msg:support.newSupportCall.selectSubject" })}
                                            />
                                        </div>
                                    </div>

                                    {subject !== SupportType.COMMERCIAL && subject !== SupportType.CONTRACT_CANCELLATION && data?.supportType !== "TECHNICAL_SUPPORT" ? (
                                        <div className=''>
                                            <span className='text-size-14 text-color-darker'>{intl.formatMessage({ id: "intl-msg:support.constants.field.subtopic" })}</span>
                                            <div className='form-group form-group-lg padding-top-10'>
                                                <Select
                                                    bsSize='lg'
                                                    value={subtopic ? [subtopic] : []}
                                                    onChange={option => setSubtopic(option?.id || '')}
                                                    options={getSupportThemeOptions(intl, subject)}
                                                    placeholder={intl.formatMessage({ id: "intl-msg:support.newSupportCall.selectTopic" })}
                                                />
                                            </div>
                                        </div>
                                    ) : null}

                                    {showVinculateOccurrence ? <>
                                        {!occurrenceId && !occurrenceData ? (
                                            <div className='padding-top-20'>
                                                <div className="">
                                                    <label
                                                        htmlFor="occurrenceSearch"
                                                        className="text-size-14 text-color-darker"
                                                    >
                                                        {intl.formatMessage({ id: "intl-msg:tas.occurrence.btn-search" })}
                                                    </label>
                                                    <div className="form-group form-group-lg padding-top-10">
                                                        <SelectCustom
                                                            className="form-control-lg"
                                                            value={[occurrenceId || '']}
                                                            onChange={(item) => {
                                                                if (!item?.id) {
                                                                    return;
                                                                }

                                                                if (item?.id && item?.id?.length < 16) {
                                                                    return;
                                                                };

                                                                setOccurrenceId(item?.id || '')
                                                            }}
                                                            loadData={handleLoadMore}
                                                            disabled={false}
                                                            isRemoved={false}
                                                            loadOnFocus={true}
                                                            openOnFocus={false}
                                                            label
                                                            autoFocus={false}
                                                            initialLimit={10}
                                                            placeholder={intl.formatMessage({ id: "intl-msg:tas.occurrence.enter-occurrence-number" })}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null}

                                        {occurrenceData ? (
                                            <MainOccurenceCard 
                                                mainOccurrenceData={occurrenceData} 
                                                onClear={() => {
                                                    setOccurrenceId(null);
                                                    setOccurrenceData(undefined);
                                                }} 
                                            />
                                        ) : null}
                                    </> : null}


                                    <div className="width-100pct">
                                        <Occurrence
                                            isLoading={isLoading}
                                            responsible={responsible}
                                            handleResponsible={(resp) => setResponsible(resp)}
                                            subject={data?.subject}
                                            dn={dn}
                                            handleDn={(dn) => setDn(dn)}
                                            chassis={chassis}
                                            handleChassis={ch => setChassis(ch)}
                                            licensePlate={licensePlate}
                                            handleLicensePlate={lp => setLicensePlate(lp)}
                                            customer={customer}
                                            handleCustomer={cr => setCustomer(cr)}
                                            dnResponsible={dnResponsible}
                                            handleDnResponsible={dn => setDnResponsible(dn)}
                                            hourMeter={hourMeter}
                                            handleHourMeter={hm => setHourMeter(hm)}
                                            odometer={odometer}
                                            handleOdometer={or => setOdometer(or)}
                                            entryDate={entryDate}
                                            handleEntryDate={date => setEntryDate(date)}
                                            isTechnicalSupport={data?.supportType === 'TECHNICAL_SUPPORT'}
                                            errors={errors}
                                            optionsRegionals={optionsRegionals}
                                            selectedRegional={selectedRegional}
                                            handleChangeRegional={(id) => setSelectedRegional([id as string])}
                                            phone={phone}
                                            handlePhone={(ph) => setPhone(ph)}
                                            occurrenceId={occurrenceId}
                                            vehicle={vehicle}
                                        />
                                    </div>

                                    <div className="width-100pct">
                                        {data?.supportType === 'TECHNICAL_SUPPORT' ? (
                                            <AdditionalDataTas
                                                isLoading={isLoading}
                                                subject={subject}
                                                tasOccurrenceNumber={data?.tasOccurrenceNumber}
                                                customerComment={customerComment}
                                                handleChangeComment={comment => setCustomerComment(comment)}
                                                errors={errors}
                                                partOrComponentName={partOrComponentName}
                                                handlePartOrComponentName={(pn) => setPartOrComponentName(pn)}
                                                partNumber={partNumber}
                                                handlePartNumber={(pn) => setPartNumber(pn)}
                                                problemDescription={problemDescription}
                                                handleProblemDescription={(pd) => setProblemDescription(pd)}
                                                diagnosticAndResults={diagnosticAndResults}
                                                handleDiagnosticAndResults={dr => setDiagnosticAndResults(dr)}
                                                problemSteps={problemSteps}
                                                handleProblemSteps={(ps) => setProblemSteps(ps)}
                                                failureFrequency={failureFrequency}
                                                handleFailureFrequency={fr => setFailureFrequency(fr)}
                                                failCodes={failCodes}
                                                handleFailCodes={rfc => setFailCodes(rfc)}
                                                repair={repair}
                                                handleRepair={r => setRepair(r)}
                                                canEditRepair={isVwEmail}
                                                observations={observations}
                                                handleObservations={obs => setObservations(obs)}
                                            />
                                        ) : (
                                            <AdditionalData
                                                isLoading={isLoading}
                                                subject={data?.subject}
                                                tasOccurrenceNumber={data?.contractNumber}
                                                customerComment={customerComment}
                                                handleChangeComment={comment => setCustomerComment(comment)}
                                                diagnose={diagnose}
                                                handleDiagnose={d => setDiagnose(d)}
                                                repair={repair}
                                                handleRepair={r => setRepair(r)}
                                                analysisReason={analysisReason}
                                                handleAnalysisReason={ar => setAnalysisReason(ar)}
                                                partName={partName}
                                                handlePartName={pn => setPartName(pn)}
                                                aeg={aeg}
                                                handleAeg={ag => setAeg(ag)}
                                                errors={errors}
                                                cancelComment={cancelComment}
                                                handleCancelComment={cm => setCancelComment(cm)}
                                                vehicleQtd={vehicleQtd}
                                                handleVehicleQtd={qtd => setVehicleQtd(qtd)}
                                                cancelReason={cancelReason}
                                                handleCancelReason={(cancel) => setCancelReason(cancel)}
                                            />
                                        )}
                                    </div>
                                </>
                            )}

                            {activeTab === 'chat' && (
                                <div className="width-100pct">
                                    <ChatOccurrenceTas
                                        disabled={data?.status === 'FINISHED'}
                                        {...tasOccurrenceChat}
                                    />
                                </div>
                            )}

                            {activeTab === 'chatVwco' && showVwcoChat && (
                                <div className="width-100pct">
                                    <ChatOccurrenceTas
                                        disabled={data?.status === 'FINISHED'}
                                        canDelete={false}
                                        title={intl.formatMessage({ id: "intl-msg:tas.support.details.chatVwco" })}
                                        {...vwcoChat}
                                    />
                                </div>
                            )}

                            {activeTab === 'attachments' && (
                                <div className="width-100pct">
                                    <SupportAttachmentsPage id={id ?? ''} isControlTower={isControlTower} />
                                </div>
                            )}

                            {activeTab === 'supportHistory' && (
                                <div className="width-100pct">
                                    <SupportHistoryPage
                                        data={logOccurence}
                                        handleEndDate={start => setEndDate(start)}
                                        handleStartDate={end => setStartDate(end)}
                                        startDate={startDate}
                                        endDate={endDate}
                                        handleStatus={c => setStatus(c)}
                                        status={status}
                                        handleUser={e => setUserSearch(e)}
                                        user={userSearch}
                                        handleSubmit={handleApplyFilterLog}
                                        isLoading={isLoadingLogs}
                                    />
                                </div>
                            )}

                            {activeTab === 'VehicleHistory' && (
                                <div className="width-100pct">
                                    <VehicleHistoryPage chassis={data?.chassis} customer={customer || vehicle?.vehicleOwner} />
                                </div>
                            )}
                        </div>

                        {activeTab === 'summary' && showVehicleContainer && (
                            <div className="min-width-400" style={{display: 'flex', flexDirection: 'column'}}>
                                <VehicleData data={vehicle} isLoading={isLoadingChassis} />
                                <HistoryOcurrence chassis={chassis} currentOccurrenceId={id} />
                            </div>
                        )}
                    </div>

                    <div className="width-100pct margin-top-20 display-flex justify-content-space-between">
                        <div>
                            <Button onClick={handleDuplicateOcurrence} disabled={isLoadingEdit || isLoading} className={isLoadingEdit ? 'btn-loading disabled' : ''}>{intl.formatMessage({ id: "intl-msg:tas.occurrence.btn-duplicate" })}</Button>
                        </div>
                        <div>
                            <Button className="margin-right-10" onClick={handleGoBack}>{intl.formatMessage({ id: "intl-msg:tas.occurrence.btn-cancel" })}</Button>

                            <Button 
                                onClick={saveForm}
                                disabled={isLoadingSaveForm} 
                                className={isLoadingSaveForm ? 'btn-loading disabled margin-right-10' : 'margin-right-10'}
                            >
                                {intl.formatMessage({ id: "intl-msg:tas.occurrence.btn-save" })}
                            </Button>

                            <Button 
                                onClick={() => handleEdit(false, true)} 
                                disabled={isLoadingEdit || isLoading} 
                                className={isLoadingEdit ? 'btn-loading disabled' : ''} bsStyle={Button.PRIMARY}
                            >
                                {intl.formatMessage({ id: "intl-msg:tas.occurrence.btn-close-save" })}
                            </Button>
                        </div>
                    </div>

                </div>

                <ChangeGroupDialog
                    show={!!pendingGroup}
                    userName={selectedUserName}
                    onConfirm={() => pendingGroup && applyGroup(pendingGroup)}
                    onCancel={() => setPendingGroup(undefined)}
                />

                <MoveStepDialog
                    show={showAdvanceStepDialog}
                    id={id}
                    data={data}
                    closePage={closePage}
                    advanceStatus={advanceStatus}
                    isDuplicated={isDuplicated}
                    isConsultant={isConsultant}
                    selected={selected}
                    isLoadingEdit={isLoadingEdit}

                    setAdvanceStatus={setAdvanceStatus}
                    setIsLoadingEdit={setIsLoadingEdit}
                    setShowAdvanceStepDialog={setShowAdvanceStepDialog}
                    updateOccurrence={async () => {
                        if (!id || !data) return;
                        await updateOccurrence(id, advanceStatus?.[0] as OccurrenceStatus, data);
                    }}
                    handleNavigateCreate={handleNavigateCreate}
                    onClose={() => setShowAdvanceStepDialog(false)}
                />

                <ErrorDialog
                    show={showNonVolksMoveErrorDialog}
                    title={intl.formatMessage({ id: "intl-msg:support.details.notAllowedTitle" })}
                    body={intl.formatMessage({ id: "intl-msg:support.details.notAllowedBody" })}
                    onClose={() => setShowNonVolksMoveErrorDialog(false)}
                />

                <UnsavedChangesLeaveDialog
                    show={showLeaveConfirmDialog}
                    isLoading={isLoadingEdit}
                    onClose={() => setShowLeaveConfirmDialog(false)}
                    onLeaveWithoutSaving={handleLeaveWithoutSaving}
                    onSave={handleLeaveWithSave}
                />
            </div>
        </div>
    )
};

export default SupportDetailsPage;